/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { SessionsService } from '../../service/sessions.service';

import { AuthService } from '../../../../auth/auth.service';

import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs';
import { MasterDataResponse } from 'projects/admin/src/app/models/masterDataResponse';
import { MasterdataService } from 'projects/admin/src/app/services/masterdata.service';
import { TherapistService } from 'projects/admin/src/app/services/therapist.service';
import { SessionTableComponent } from 'projects/app-core/src/app/session/components/session-table/session-table.component';
import { Permissions } from 'projects/app-core/src/auth/models/roles';
import {
  catchError,
  filter,
  forkJoin,
  lastValueFrom,
  of,
  Subscription,
  take,
} from 'rxjs';
import { IAnyoError } from '../../../../models/errorModal';
import { AnyoSortDirection } from '../../../../models/gridRequest';
import { FileUtilsService } from '../../../../service/fileService';
import { AlertBoxComponent } from '../../../components/alert-box/alert-box.component';
import { SessionExportData } from '../../models/SessionExportData';
import { SessionFeedbackFormSubmitRequest } from '../../models/sessionFeedbackFormSubmitRequest';
import {
  SessionGridRequest,
  SessionGridTab,
} from '../../models/sessionGridRequest';
import { SessionGridResponse } from '../../models/sessionGridResponse';
import {
  CancelSessionRequest,
  ConfirmSessionRequest,
  UpdateSessionRequest,
} from '../../models/SessionRequest';
import { SessionGridStatsData } from '../../models/sessionStatsData';

interface therapistSelectOptions {
  label: string;
  value: string;
}

import { getFullName } from '../../../utils/utils';
@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.scss'],
})
export class SessionComponent implements OnInit, OnDestroy {
  @ViewChild('sessionTableComponent')
  sessionTableComponent?: SessionTableComponent;
  @ViewChild('allSessionTableComponent')
  allSessionTableComponent?: SessionTableComponent;
  dateFormat = 'dd/MM/yyyy';
  globalSearchInput: string = '';
  mode: string = 'Therapist';
  id: string = '';
  patientId: string = '';
  dateRange: Date[] | undefined;
  date: string = '';
  time: string = '';
  upcomingDate: string = '';
  upcomingTime: string = '';
  callLink: string = '';
  isAlert: boolean = false;
  confirmAlert: boolean = false;
  confirmHeader: string = 'Confirm Date';
  patientHeader: string = 'Intake Form';
  patient: any = {};
  cancelHeader: string = 'Cancel Appointment';
  cancelBody: string = 'Reason for Cancellation';
  alertSuccess: string = 'Date';
  firstName: string = '';
  lastName: string = '';
  fullNameTherapist: string = '';
  tabs = [SessionGridTab.NEW_APPOINTMENTS, SessionGridTab.ALL];
  selectedTab: number = 0;
  therapistDetailsWithId: any[] = [];
  tableSpinner = false;
  sessionTableQuery: SessionGridRequest | undefined;
  tableData: SessionGridResponse = {
    data: [],
    filterOptions: {
      partners: [],
      therapists: [],
      sessionStatus: [],
      partnerId: [],
    },
    pageNum: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
  };
  isAdminPortal = false;
  private pageSize: number = 10;
  sessionCompleted = 'Yes';
  showFeedBackForm = false;
  therapistSelectData: therapistSelectOptions[] | undefined;
  showUpdateButton!: boolean;
  showNewBookingBtn: boolean = false;
  showOverrideStatusBtn: boolean = false;
  therapistId = '';
  therapistName = '';
  queryUserEmail: string | undefined;
  queryTherapistEmail: string | undefined;
  masterData: MasterDataResponse | undefined;
  private queryParamsSubscription: Subscription | undefined;
  private isInitializing: boolean = true;
  constructor(
    private toastService: ToastService,
    private auth: AuthService,
    private sessionService: SessionsService,
    private therapistService: TherapistService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fileUtil: FileUtilsService,
    public masterDataService: MasterdataService,
    private location: Location,
    private modal: NzModalService,
  ) { }
  sessionStatsData: SessionGridStatsData = {
    totalSessions: 0,
    confirmedSessions: 0,
    cancelledSessions: 0,
    completedSessions: 0,
    noShowUserSessions: 0,
    noShowTherapistSessions: 0,
    techIssueSessions: 0,
    feedbackPendingSessions: 0,
  };

  getSessionsStats() {
    this.sessionService.sessionGridStats(this.sessionTableQuery!).subscribe({
      next: (value) => {
        const response = this.sessionService.mapSessionGridStatsResp(value);
        this.sessionStatsData = response;
      },
      error: (value) => {
        const errorBody = value.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  async ngOnInit() {
    this.tableSpinner = true;

    try {
      // Wait for authentication status
      const user = await lastValueFrom(
        this.auth.currentAuthStatus.pipe(
          filter((user) => !!user),
          take(1),
        ),
      );

      if (!user) return;

      // Extract query parameters once
      const queryParams = this.activatedRoute.snapshot.queryParams;
      this.queryUserEmail = queryParams['userId'];
      this.queryTherapistEmail = queryParams['therapistId'];

      // Load grid request from URL first
      this.loadGridRequestFromUrl();

      // If we loaded from URL, sync the UI state
      if (this.sessionTableQuery) {
        this.syncUIWithGridRequest();
      }

      // Subscribe to query parameter changes for URL navigation (skip initial emission)
      this.queryParamsSubscription = this.activatedRoute.queryParams
        .pipe(
          filter((params, index) => index > 0), // Skip the first emission to avoid overriding initial load
        )
        .subscribe(async (params) => {
          if (params['gridRequest']) {
            const decodedRequest =
              this.sessionService.decodeGridRequestFromBase64(
                params['gridRequest'],
              );
            if (decodedRequest) {
              this.sessionTableQuery = decodedRequest;
              // Preserve existing query parameters for user and therapist emails
              if (
                this.queryUserEmail &&
                !this.sessionTableQuery.filters?.USER_ID?.includes(
                  this.queryUserEmail,
                )
              ) {
                this.sessionTableQuery.filters?.USER_ID?.push(
                  this.queryUserEmail,
                );
              }
              if (
                this.queryTherapistEmail &&
                !this.sessionTableQuery.filters?.THERAPIST_EMAIL?.includes(
                  this.queryTherapistEmail,
                )
              ) {
                this.sessionTableQuery.filters?.THERAPIST_EMAIL?.push(
                  this.queryTherapistEmail,
                );
              }
              // Sync UI state with loaded grid request
              this.syncUIWithGridRequest();
              // Reload data with new state
              await this.listSession();
            }
          }
        });

      // Check portal type
      const isAdminPortal = this.router.routerState.snapshot.url.includes(
        'therapist/session/admin',
      );

      // Set permissions
      const additionalPermissions =
        user.customClaims?.additionalPermissions ?? [];
      this.showNewBookingBtn = additionalPermissions.includes(
        Permissions.AdminBookNewSession,
      );
      this.showOverrideStatusBtn = additionalPermissions.includes(
        Permissions.OverrideSessionStatus,
      );
      // Initialize sessionTableQuery only if not loaded from URL
      if (!this.sessionTableQuery) {
        this.sessionTableQuery = {
          sort: {
            SESSION_DATE: AnyoSortDirection.DESC,
            THERAPIST_RATING: AnyoSortDirection.DESC,
          },
          dateFilters: undefined,
          export: false,
          filters: {
            SESSION_STATUS: [],
            THERAPIST_EMAIL: [],
            USER_ID: [],
            PARTNER_ID: [],
            HIDE_TEST_BOOKING: ['true'],
            SESSION_TAG: [],
          },
          from: undefined,
          globalSearch: [],
          page: 1,
          pageSize: this.pageSize,
          searchQuery: undefined,
          tab: SessionGridTab.NEW_APPOINTMENTS,
          to: undefined,
        };
        this.updateUrlWithGridRequest();
      }
      // Add query parameters to filters
      if (this.queryTherapistEmail) {
        this.sessionTableQuery.filters?.THERAPIST_EMAIL!.push(
          this.queryTherapistEmail,
        );
      }
      if (this.queryUserEmail) {
        this.sessionTableQuery.filters?.USER_ID!.push(this.queryUserEmail);
      }

      // Batch API calls for better performance
      const apiCalls = [];

      // Add master data call
      apiCalls.push(
        this.masterDataService.masterDataList().pipe(
          catchError((error) => {
            const errorBody = error.error as IAnyoError;
            this.toastService.showAnyoErrorToast(errorBody.description);
            return of(null);
          }),
        ),
      );

      // Add therapist list call
      apiCalls.push(
        this.therapistService.therapistList().pipe(
          catchError((error) => {
            console.log('Therapist list error:', error);
            return of([]);
          }),
        ),
      );

      // Add therapist by email call for non-admin portals
      if (!isAdminPortal) {
        this.isAdminPortal = true;
        apiCalls.push(
          this.therapistService.getTherapistByEmail(user.email!).pipe(
            catchError((error) => {
              const errorBody = error.error as IAnyoError;
              this.toastService.showAnyoErrorToast(errorBody.description);
              return of(null);
            }),
          ),
        );
      }

      // Execute all API calls in parallel
      const results = await lastValueFrom(forkJoin(apiCalls));

      // Process results
      const masterDataResult = results[0];
      const therapistListResult = results[1] as any[];
      const therapistByEmailResult = results[2];

      if (masterDataResult) {
        this.masterData = masterDataResult as MasterDataResponse;
      }

      if (
        therapistListResult &&
        Array.isArray(therapistListResult) &&
        therapistListResult.length > 0
      ) {
        therapistListResult.forEach((element: any) => {
          if (element.status === 'active') {
            const obj: any = {
              id: element._id,
              firstName: element.firstName,
              lastName: element.lastName,
              email: element.email,
              name: getFullName(element.firstName, element.lastName),
            };
            this.therapistDetailsWithId.push(obj);
          }
        });

        this.therapistSelectData = therapistListResult.map((cat: any) => ({
          label: cat.firstName,
          value: cat._id!.toString(),
        }));
      }

      if (therapistByEmailResult && !isAdminPortal) {
        const therapist = therapistByEmailResult as any;
        this.therapistId = therapist._id!;
        this.therapistName = getFullName(therapist.firstName, therapist.lastName);
        this.toastService.showSuccess('therapist fetched');
      }

      // Load session data
      await this.listSession();
    } catch (error) {
      this.toastService.showError('Failed to initialize component');
    } finally {
      this.tableSpinner = false;
      // Allow tabChange to work after initialization is complete
      this.isInitializing = false;
    }
  }

  submitFeedBack($event: any) {
    this.selectedTab === 0
      ? (this.sessionTableComponent!.feedbackFormSubmitLoading = true)
      : (this.allSessionTableComponent!.feedbackFormSubmitLoading = true);
    const request: SessionFeedbackFormSubmitRequest = {
      sessionCompleted: $event.sessionCompleted,
      sessionId: $event.sessionId,
      remarks: $event.remarks,
      sessionStatus: $event.sessionStatus,
    };
    this.sessionService.updateSessionFeedbackFom(request).subscribe({
      next: async () => {
        this.toastService.showSuccess('Feedback updated successfully');
        this.selectedTab === 0
          ? (this.sessionTableComponent!.showFeedBackForm = false)
          : (this.allSessionTableComponent!.showFeedBackForm = false);
        this.selectedTab === 0
          ? (this.sessionTableComponent!.feedbackFormSubmitLoading = false)
          : (this.allSessionTableComponent!.feedbackFormSubmitLoading = false);

        await this.listSession();
      },
      error: (error) => {
        this.selectedTab === 0
          ? (this.sessionTableComponent!.feedbackFormSubmitLoading = false)
          : (this.allSessionTableComponent!.feedbackFormSubmitLoading = false);
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  showPatientDetailsFn(id: string) {
    const appointment = this.tableData.data.find((value) => value.id === id);
    if (!appointment) {
      this.toastService.showError('Patient details not found');
    }

    this.patient.name = appointment!.clientDetails.name;
    this.patient.gender = appointment!.clientDetails.gender;
    this.patient.pastTherapyExperience =
      appointment!.clientDetails.pastTherapyExp;
    this.patient.lastSession = '';
    this.patient.pastMedCondition =
      appointment!.clientDetails.pastMedicalConditions;
    if (appointment!.clientDetails.medication) {
      this.patient.isMedication = 'Yes';
      this.patient.medication = appointment!.clientDetails.medication;
    } else {
      this.patient.isMedication = 'No';
      this.patient.medication = 'Nil';
    }
    this.patient.currentSymptoms = appointment!.clientDetails.currentSymptoms;
    this.patientAlert = true;
  }

  close() {
    this.patientAlert = false;
    this.cancelAlert = false;
    this.confirmAlert = false;
  }

  assignGoogleMeetFn(sessionId: string) {
    this.modal.confirm({
      nzTitle: 'Assign a new Google Meet link?',
      nzContent:
        'This moves the session from Cloudflare to Google Meet. The current join link is replaced and the Cloudflare room is cancelled, so participants who already have the old link will need the new Meet link. This cannot be undone.',
      nzOkText: 'Assign Google Meet',
      nzOkDanger: true,
      nzOnOk: () =>
        new Promise<void>((resolve) => {
          this.sessionService.assignGoogleMeet(sessionId).subscribe({
            next: async (res) => {
              this.toastService.showSuccess(
                `Google Meet assigned: ${res.callLink}`,
              );
              await this.listSession();
              resolve();
            },
            error: (error) => {
              const errorBody = error.error as IAnyoError;
              this.toastService.showAnyoErrorToast(
                errorBody?.description ??
                  'Failed to assign Google Meet link. Please try again.',
              );
              resolve();
            },
          });
        }),
    });
  }

  @ViewChild('cancelAppointmentAlertBox')
  cancelAppointmentAlertBox!: AlertBoxComponent;

  cancelAppointment(event: string) {
    this.cancelAppointmentAlertBox.loading = true;
    const request: CancelSessionRequest = {
      reasonForCancellation: [event],
      isAdmin: !this.isExpert,
    };

    this.sessionService.cancelAppointment(this.id, request).subscribe({
      next: async () => {
        this.cancelAlert = false;
        this.cancelAppointmentAlertBox.loading = false;
        this.toastService.showSuccess('Appointment cancelled successfully');

        await this.listSession();
      },
      error: (error) => {
        this.cancelAppointmentAlertBox.loading = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  @ViewChild('confirmAppointmentAlertBox')
  confirmAppointmentAlertBox!: AlertBoxComponent;

  confirmAppointment(event: any) {
    this.confirmAppointmentAlertBox.loading = true;
    const dateTimeMoment = moment(
      `${event.suggestedDate} ${event.suggestedTime}`,
    );
    const startTimeEpochInSeconds = dateTimeMoment.format('x');

    const request: ConfirmSessionRequest = {
      startTime: startTimeEpochInSeconds!,
      therapistId: [],
    };
    request.therapistId = event.therapistId;
    this.sessionService.confirmAppointment(this.id, request).subscribe({
      next: async () => {
        this.toastService.showSuccess('Appointment confirmed successfully');
        this.confirmAlert = false;
        this.confirmAppointmentAlertBox.loading = false;

        await this.listSession();
      },
      error: (error) => {
        this.confirmAppointmentAlertBox.loading = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  updateAppointment(event: any) {
    this.selectedTab === 0
      ? (this.sessionTableComponent!.updateAppointmentSubmitLoading = true)
      : (this.allSessionTableComponent!.updateAppointmentSubmitLoading = true);
    const request: UpdateSessionRequest = {
      startTime: event.startTime,
      therapistId: event.therapistId,
    };
    this.sessionService.updateAppointment(event.sessionId, request).subscribe({
      next: async () => {
        this.cancelAlert = false;
        this.toastService.showSuccess('Appointment Updated successfully');
        this.selectedTab === 0
          ? (this.sessionTableComponent!.updateAppointmentSubmitLoading = false)
          : (this.allSessionTableComponent!.updateAppointmentSubmitLoading =
            false);
        this.selectedTab === 0
          ? (this.sessionTableComponent!.visibleUpdateAppointment = false)
          : (this.allSessionTableComponent!.visibleUpdateAppointment = false);
        this.tableSpinner = false;

        await this.listSession();
      },
      error: (error) => {
        this.selectedTab === 0
          ? (this.sessionTableComponent!.updateAppointmentSubmitLoading = false)
          : (this.allSessionTableComponent!.updateAppointmentSubmitLoading =
            false);
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  disabledDate = (current: Date) => {
    return moment(current).isBefore(moment('01/10/2023', 'dd/MM/YYYY'));
  };
  cancelAlert: boolean = false;
  isExpert: boolean = false;
  patientAlert: boolean = false;

  async nzPageSizeChange(pageSize: number) {
    this.sessionTableQuery!.pageSize = pageSize;
    this.updateUrlWithGridRequest();
  }

  async nzPageIndexChange(page: number) {
    if (this.sessionTableQuery) {
      this.sessionTableQuery!.page = page;
      this.updateUrlWithGridRequest();
    }
  }
  firstTime = true;
  async listSession() {
    try {
      this.tableSpinner = true;
      this.getSessionsStats();

      if (this.sessionTableComponent) {
        this.sessionTableQuery!.filters!.HIDE_TEST_BOOKING = [
          this.hideTestBook
            ? this.hideTestBook.toString()
            : this.hideTestBook.toString(),
        ];
      }

      if (this.allSessionTableComponent) {
        this.sessionTableQuery!.filters!.HIDE_TEST_BOOKING = [
          this.allHideTestBook
            ? this.allHideTestBook.toString()
            : this.allHideTestBook.toString(),
        ];
      }

      const isAdminPortal =
        this.router.routerState.snapshot.url.includes('/admin');
      if (isAdminPortal) {
        this.showUpdateButton = true;
        this.tableData = await lastValueFrom(
          this.sessionService.fetchSessions(this.sessionTableQuery!),
        );
        this.tableSpinner = false;
      } else if (this.router.routerState.snapshot.url.includes('/therapist')) {
        this.showUpdateButton = false;
        this.tableData = await lastValueFrom(
          this.sessionService.fetchSessionsForTherapist(
            this.sessionTableQuery!,
          ),
        );
        this.tableSpinner = false;
      }
      if (this.firstTime) {
        // Auto-switch tab logic when global search is applied and no results found
        await this.handleAutoTabSwitch();
        this.firstTime = false;
      }

      if (this.sessionTableComponent) {
        this.sessionTableComponent.setTherapistFilterData(
          this.tableData.filterOptions,
        );
        this.sessionTableComponent.setSessionStatusFilterData(
          this.tableData.filterOptions,
        );
        this.sessionTableComponent.setPartnerIdFilterData(
          this.tableData.filterOptions,
        );
        this.sessionTableComponent.setPartnerNameFilterData(
          this.tableData.filterOptions,
        );
        this.sessionTableComponent.setSessionTagFilterData(
          this.tableData.filterOptions,
        );
      }
      if (this.allSessionTableComponent) {
        this.allSessionTableComponent.setTherapistFilterData(
          this.tableData.filterOptions,
        );
        this.allSessionTableComponent.setSessionStatusFilterData(
          this.tableData.filterOptions,
        );
        this.allSessionTableComponent.setPartnerIdFilterData(
          this.tableData.filterOptions,
        );
        this.allSessionTableComponent.setPartnerNameFilterData(
          this.tableData.filterOptions,
        );
        this.allSessionTableComponent.setSessionTagFilterData(
          this.tableData.filterOptions,
        );
      }
    } catch (e) {
      this.tableSpinner = false;
      this.toastService.showError('Something went wrong');
    }
  }

  async searchGlobal() {
    this.sessionTableQuery!.globalSearch = [this.globalSearchInput];
    this.updateUrlWithGridRequest();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async dateChange(_: Date[]) {
    if (this.dateRange && this.dateRange.length == 2) {
      this.sessionTableQuery!.from = Number(
        moment(this.dateRange[0]).format('x'),
      );
      this.sessionTableQuery!.to = Number(
        moment(this.dateRange[1]).format('x'),
      );
    } else {
      this.sessionTableQuery!.from = undefined;
      this.sessionTableQuery!.to = undefined;
    }
    this.updateUrlWithGridRequest();
  }

  async resetFilter() {
    this.globalSearchInput = '';
    this.sessionTableQuery = {
      export: false,
      sort: {
        SESSION_DATE: AnyoSortDirection.DESC,
        THERAPIST_RATING: AnyoSortDirection.DESC,
      },
      filters: {
        THERAPIST_EMAIL: [],
        SESSION_STATUS: [],
        HIDE_TEST_BOOKING: ['true'],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      },
      globalSearch: [],
      page: 1,
      pageSize: this.pageSize,
      tab: this.tabs[this.selectedTab],
    };
    if (this.queryTherapistEmail) {
      this.sessionTableQuery!.filters?.THERAPIST_EMAIL!.push(
        this.queryTherapistEmail,
      );
    }
    if (this.queryUserEmail) {
      this.sessionTableQuery!.filters?.USER_ID!.push(this.queryUserEmail);
    }

    this.dateRange = [];
    // if (this.dateRange && this.dateRange.length == 2) {
    //   this.sessionTableQuery.from = Number(
    //     moment(this.dateRange[0]).format('X'),
    //   );
    //   this.sessionTableQuery.to = Number(moment(this.dateRange[1]).format('X'));
    // }
    if (this.sessionTableComponent) {
      this.sessionTableComponent!.resetValues();
    }
    if (this.allSessionTableComponent) {
      this.allSessionTableComponent!.resetValues();
    }
    this.updateUrlWithGridRequest();
    await this.listSession();
  }

  async tabChange($event: NzTabChangeEvent) {
    // Skip tabChange during component initialization
    if (this.isInitializing) {
      return;
    }

    this.selectedTab = $event.index!;
    this.tableData = {
      data: [],
      filterOptions: {
        partners: [],
        therapists: [],
        sessionStatus: [],
        partnerId: [],
      },
      pageNum: 1,
      pageSize: 10,
      totalPages: 0,
      totalRecords: 0,
    };

    this.globalSearchInput = '';
    this.sessionTableQuery = {
      export: false,
      sort: {
        SESSION_DATE: AnyoSortDirection.DESC,
        THERAPIST_RATING: AnyoSortDirection.DESC,
      },
      filters: {
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        HIDE_TEST_BOOKING: ['true'],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      },
      globalSearch: [],
      page: 1,
      pageSize: this.pageSize,
      tab: this.tabs[this.selectedTab],
    };
    if (this.queryTherapistEmail) {
      this.sessionTableQuery!.filters?.THERAPIST_EMAIL!.push(
        this.queryTherapistEmail,
      );
    }
    if (this.queryUserEmail) {
      this.sessionTableQuery!.filters?.USER_ID!.push(this.queryUserEmail);
    }
    if (this.dateRange && this.dateRange.length == 2) {
      this.sessionTableQuery!.from = Number(
        moment(this.dateRange[0]).format('X'),
      );
      this.sessionTableQuery!.to = Number(
        moment(this.dateRange[1]).format('X'),
      );
    }
    if (this.sessionTableComponent) {
      this.sessionTableComponent.resetValues();
    }
    if (this.allSessionTableComponent) {
      this.allSessionTableComponent.resetValues();
    }

    if ($event.index == 0) {
      this.sessionTableQuery!.tab = SessionGridTab.NEW_APPOINTMENTS;
    }
    if ($event.index == 1) {
      this.sessionTableQuery!.tab = SessionGridTab.ALL;
    }
    this.updateUrlWithGridRequest();
  }

  async sessionDateSort($event: string | null) {
    this.sessionTableQuery!.sort = {
      SESSION_DATE: undefined,
      THERAPIST_RATING: undefined,
    };
    if ($event) {
      this.sessionTableQuery!.sort!.SESSION_DATE =
        $event === 'ascend' ? AnyoSortDirection.ASC : AnyoSortDirection.DESC;
    } else {
      this.sessionTableQuery!.sort!.SESSION_DATE = AnyoSortDirection.ASC;
    }
    this.updateUrlWithGridRequest();
  }

  async therapistRatingSort($event: string | null) {
    this.sessionTableQuery!.sort = {
      SESSION_DATE: undefined,
      THERAPIST_RATING: undefined,
    };

    if ($event) {
      this.sessionTableQuery!.sort!.THERAPIST_RATING =
        $event === 'ascend' ? AnyoSortDirection.ASC : AnyoSortDirection.DESC;
    } else {
      this.sessionTableQuery!.sort!.THERAPIST_RATING = AnyoSortDirection.ASC;
    }
    this.updateUrlWithGridRequest();
  }

  async therapistFilterFn($event: string[]) {
    if (!this.sessionTableQuery!.filters) {
      this.sessionTableQuery!.filters = {
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        HIDE_TEST_BOOKING: [],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      };
    }
    if ($event && $event.length) {
      this.sessionTableQuery!.filters!.THERAPIST_EMAIL = $event;
      this.updateUrlWithGridRequest();
    }
  }

  async sessionStatusFilter($event: string[]) {
    if (!this.sessionTableQuery!.filters) {
      this.sessionTableQuery!.filters = {
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        HIDE_TEST_BOOKING: [],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      };
    }
    if ($event && $event.length) {
      this.sessionTableQuery!.filters!.SESSION_STATUS = $event;
      this.updateUrlWithGridRequest();
    }
  }

  userName: string = '';
  userEmail: string = '';

  cancelAppointmentFn($event: {
    userName: string;
    userEmail: string;
    id: string;
  }) {
    this.id = $event.id;
    this.userEmail = $event.userEmail;
    this.userName = $event.userName;
    this.isExpert = false;
    this.cancelAlert = true;
  }

  extractRequestedDate(input: string): string | null {
    const dateRegex = /Requested Date\s*:\s*([\d/]+)/;
    const match = input.match(dateRegex);
    return match ? match[1] : null;
  }

  extractRequestedTime(input: string): string | null {
    const timeRegex = /Requested Time\s*:\s*([\d:]+\s*[APM]+)/;
    const match = input.match(timeRegex);
    return match ? match[1] : null;
  }
  confirmAppointmentFn($event: string) {
    const appointment = this.tableData.data.find(
      (value) => value.id === $event,
    );
    if (!appointment) {
      return;
    }
    let text = '';
    appointment.remarks?.map((data) => {
      text = data.remark;
    });
    this.upcomingTime = moment(appointment.sessionStart, 'x').format('HH:mm');
    this.upcomingDate = moment(appointment.sessionDate, 'x').format(
      'YYYY-MM-DD',
    );
    this.id = $event;
    this.fullNameTherapist = appointment.therapistDetails.id;
    this.callLink = appointment.callLink ? appointment.callLink : '';
    const requestedDate = this.extractRequestedDate(text);
    const requestedTime = this.extractRequestedTime(text);
    if (requestedDate) {
      this.upcomingDate = moment(requestedDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD',
      );
    }
    if (requestedTime) {
      this.upcomingTime = moment(requestedTime, 'hh:mm A').format('HH:mm');
    }
    this.confirmAlert = true;
  }

  async reloadTableFn() {
    this.updateUrlWithGridRequest();
  }

  hideTestBook = true;
  allHideTestBook = true;

  async hideTestBookingFn($event: boolean) {
    if (this.sessionTableComponent) {
      this.hideTestBook = $event;
    }
    if (this.allSessionTableComponent) {
      this.allHideTestBook = $event;
    }
    if (!this.sessionTableQuery!.filters) {
      this.sessionTableQuery!.filters = {
        HIDE_TEST_BOOKING: [],
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      };
    }
    this.sessionTableQuery!.filters!.HIDE_TEST_BOOKING = [$event.toString()];
    this.updateUrlWithGridRequest();
  }

  async filterSessionTagFn($event: string[]) {
    if (!this.sessionTableQuery!.filters) {
      this.sessionTableQuery!.filters = {
        HIDE_TEST_BOOKING: [],
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      };
    }
    this.sessionTableQuery!.filters!.SESSION_TAG = $event;
    this.updateUrlWithGridRequest();
  }

  async filterPartnerIdFn($event: string[]) {
    if (!this.sessionTableQuery!.filters) {
      this.sessionTableQuery!.filters = {
        HIDE_TEST_BOOKING: [],
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      };
    }
    this.sessionTableQuery!.filters!.PARTNER_ID = $event;
    this.updateUrlWithGridRequest();
  }

  async filterPartnerNameFn($event: string[]) {
    if (!this.sessionTableQuery!.filters) {
      this.sessionTableQuery!.filters = {
        HIDE_TEST_BOOKING: [],
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      };
    }
    this.sessionTableQuery!.filters!.PARTNER_ID = $event;
    this.updateUrlWithGridRequest();
  }

  async exportDataFn() {
    this.sessionTableQuery!.export = true;
    this.tableSpinner = true;
    const gridResp = await lastValueFrom(
      this.sessionService.fetchSessions(this.sessionTableQuery!),
    );
    const exportData = gridResp.data.map((value) => {
      const payload: SessionExportData = {
        createdDate: moment(value.appointmentRequestDate, 'x').format(
          'DD/MM/YYYY',
        ),
        email: value.clientDetails.email,
        endTime: moment(value.sessionEnd, 'x').format('hh:mm a'),
        name: value.clientDetails.name,
        partnerId: value.clientDetails.partnerId,
        partnerName: value.clientDetails.partnerName,
        remarks: value.remarks?.map((value1) => value1.remark).join(',') || '',
        sessionDate: moment(value.sessionDate, 'x').format('DD/MM/YYYY'),
        startTime: moment(value.sessionDate, 'x').format('hh:mm a'),
        status: value.sessionStatus,
        therapistName: value.therapistDetails.therapistName,
      };
      return payload;
    });
    try {
      this.fileUtil.exportCSV<SessionExportData>(
        exportData,
        `sessions_export_${moment().format('dd/mm/yyy hh:mm a')}`,
      );
      this.tableSpinner = false;
    } catch (e) {
      this.toastService.showError('Export Error');
      this.tableSpinner = false;
    }
  }

  sessionDateFilter($event: Date[]) {
    if ($event && $event.length == 2) {
      const startDate = moment($event[0]).startOf('day').toDate();
      const endDate = moment($event[1]).endOf('day').toDate();
      const isToday = moment(startDate).isSame(endDate, 'day');
      this.sessionTableQuery = {
        sort: {
          SESSION_DATE: AnyoSortDirection.ASC,
          THERAPIST_RATING: AnyoSortDirection.ASC,
        },
        dateFilters: {
          SESSION_DATE: {
            from: isToday
              ? moment($event[0]).startOf('day').toDate()
              : startDate,
            to: isToday ? moment($event[1]).endOf('day').toDate() : endDate,
          },
        },
        export: false,
        filters: {
          SESSION_STATUS: [],
          THERAPIST_EMAIL: [],
          USER_ID: [],
          PARTNER_ID: [],
          HIDE_TEST_BOOKING: ['true'],
          SESSION_TAG: [],
        },
        from: undefined,
        globalSearch: [],
        page: 1,
        pageSize: this.pageSize,
        searchQuery: undefined,
        tab:
          this.selectedTab == 0
            ? SessionGridTab.NEW_APPOINTMENTS
            : SessionGridTab.ALL,
        to: undefined,
      };

      this.updateUrlWithGridRequest();
    }
  }

  private updateUrlWithGridRequest(): void {
    if (this.sessionTableQuery) {
      const encodedRequest = this.sessionService.encodeGridRequestToBase64(
        this.sessionTableQuery,
      );
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { gridRequest: encodedRequest },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
      this.listSession();
    }
  }

  private loadGridRequestFromUrl(): void {
    const params = this.activatedRoute.snapshot.queryParams;
    if (params['gridRequest']) {
      const decodedRequest = this.sessionService.decodeGridRequestFromBase64(
        params['gridRequest'],
      );
      if (decodedRequest) {
        this.sessionTableQuery = decodedRequest;
        // Preserve existing query parameters for user and therapist emails
        if (
          this.queryUserEmail &&
          !this.sessionTableQuery.filters?.USER_ID?.includes(
            this.queryUserEmail,
          )
        ) {
          this.sessionTableQuery.filters?.USER_ID?.push(this.queryUserEmail);
        }
        if (
          this.queryTherapistEmail &&
          !this.sessionTableQuery.filters?.THERAPIST_EMAIL?.includes(
            this.queryTherapistEmail,
          )
        ) {
          this.sessionTableQuery.filters?.THERAPIST_EMAIL?.push(
            this.queryTherapistEmail,
          );
        }
        // Sync UI state with loaded grid request
        this.syncUIWithGridRequest();
      }
    }
  }

  async handleAutoTabSwitch() {
    // Only proceed if there's a global search and we're on the upcoming sessions tab
    if (this.globalSearchInput && this.selectedTab === 0) {
      // Check if current results are empty
      const hasNoResults =
        !this.tableData ||
        (this.tableData.data && this.tableData.data.length === 0) ||
        (Array.isArray(this.tableData) && this.tableData.length === 0);

      if (hasNoResults) {
        // Switch to completed sessions tab and search there
        this.selectedTab = 1;
        this.sessionTableQuery!.tab = SessionGridTab.ALL;

        // Re-run the search in the completed tab
        try {
          this.tableSpinner = true;
          const isAdminPortal =
            this.router.routerState.snapshot.url.includes('/admin');
          if (isAdminPortal) {
            this.tableData = await lastValueFrom(
              this.sessionService.fetchSessions(this.sessionTableQuery!),
            );
          } else if (
            this.router.routerState.snapshot.url.includes('/therapist')
          ) {
            this.tableData = await lastValueFrom(
              this.sessionService.fetchSessionsForTherapist(
                this.sessionTableQuery!,
              ),
            );
          }
          this.tableSpinner = false;
          // Update URL to reflect the tab change
          this.updateUrlWithGridRequest();
        } catch (error) {
          this.tableSpinner = false;
          console.error('Error switching tabs for global search:', error);
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  private syncUIWithGridRequest(): void {
    if (!this.sessionTableQuery) return;
    // Sync global search input
    if (
      this.sessionTableQuery.globalSearch &&
      this.sessionTableQuery.globalSearch.length > 0
    ) {
      this.globalSearchInput = this.sessionTableQuery.globalSearch[0];
    }

    // Sync selected tab
    if (this.sessionTableQuery.tab === SessionGridTab.NEW_APPOINTMENTS) {
      this.selectedTab = 0;
    } else if (this.sessionTableQuery.tab === SessionGridTab.ALL) {
      this.selectedTab = 1;
    }

    // Sync date range if present
    if (this.sessionTableQuery.from && this.sessionTableQuery.to) {
      this.dateRange = [
        new Date(this.sessionTableQuery.from),
        new Date(this.sessionTableQuery.to),
      ];
    }

    // Sync hide test booking flags
    if (this.sessionTableQuery.filters?.HIDE_TEST_BOOKING) {
      const hideTestBookValue =
        this.sessionTableQuery.filters.HIDE_TEST_BOOKING[0] === 'true';
      this.hideTestBook = hideTestBookValue;
      this.allHideTestBook = hideTestBookValue;
    }
  }
}
